export default function StickyBottomBar() {
  return (
    <div
      className="sticky-bottom-bar fixed bottom-0 left-0 right-0 z-50 px-3 pt-3 md:hidden"
      style={{
        backgroundColor: 'rgba(8,15,12,0.97)',
        borderTop: '1px solid rgba(10,92,68,0.4)',
        backdropFilter: 'blur(16px)',
        /* Reserve space for iOS home indicator on notched phones */
        paddingBottom: 'calc(12px + env(safe-area-inset-bottom, 0px))',
        paddingLeft: 'max(12px, env(safe-area-inset-left, 0px))',
        paddingRight: 'max(12px, env(safe-area-inset-right, 0px))',
      }}
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between gap-2">
        <p
          className="font-dm text-brand-text text-xs font-medium leading-tight flex-1 min-w-0"
          style={{ lineHeight: '1.3' }}
        >
          <span style={{ color: '#AAFF45' }}>🔥</span> Try Free Until You Book Your First Job
        </p>
        <a
          href="https://apex-emerald-ai.com/contact"
          className="whitespace-nowrap font-dm font-bold text-sm px-4 py-2.5 rounded-lg cursor-pointer hover:brightness-110 active:scale-95 transition-all duration-200 flex-shrink-0"
          style={{
            backgroundColor: '#AAFF45',
            color: '#080F0C',
            minHeight: '44px',
            display: 'flex',
            alignItems: 'center',
            boxShadow: '0 0 16px rgba(170,255,69,0.4)',
          }}
        >
          Claim Free Trial →
        </a>
      </div>
    </div>
  );
}
